var cm = new TimelineMax({paused: true});
var setMotion = function(){
	cm.addLabel('init')
	.from($('.contents_tit'), 0.84, {y: -15, alpha: 0, ease: Power3.easeOut}, "init+=0.8")
	.from($('.contents_txt'), 0.84, {y: 10, alpha: 0, ease: Power3.easeOut}, "init+=1.3")
	.staggerFrom($(".contents_con > div"), 0.5, {y: -30, alpha: 0, ease: Power3.easeOut}, 0.15, "init+=1.5")
	.from($('.contents_char'), 0.84, {x: 30, alpha: 0, ease: Power3.easeOut}, "init+=1.8")
};

let initAnimation = false;

const onStart = () => {

};

const onComplete = () => {

};

const onAnimation = () => {
    $(window).trigger("resize");
	if (!initAnimation) {
		initAnimation = true;
		setMotion();
	}else{
		cm.seek(0);
		cm.pause(0);
	}
	cm.play();
};

export default {
    onStart,
    onComplete,
    onAnimation,
};



// WEBPACK FOOTER //
// ./src/js/page/contents.js